import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { CommonServicesService } from 'src/app/services/common-services.service';
import { DataManipService } from 'src/app/services/data-sharing.service';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  styleUrls: ['./default-header.component.scss'],
  standalone: false
})
export class DefaultHeaderComponent implements OnInit {

  userName: string = '';
  nameLogo: string = '';
  branchName: string = '';
  profileImg: string = '';

  constructor(
    public common: CommonServicesService,
    private dataMnp: DataManipService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.branchName = this.dataMnp.loginData.branchname;
    this.userName = this.dataMnp.loginData.username;
    this.profileImg = this.dataMnp.loginData.profileimg ?? '';
    this.nameLogo = this.userName.substring(0, 1);
    if (this.dataMnp.loginData.clientkey) {
      document.title = `SDC [${this.dataMnp.loginData.clientkey}]`;
    }
  }

  toggle(): void {
    document.body.classList.toggle('sidebar-lg-show');
    window.dispatchEvent(new Event('resize'));
  }

  logout(): void {
    this.authService.logout();
  }
}
